import { ITrainerHorseListPageState } from "interfaces/ITrainerHorseListPageState";
import {
  ITrainerHorseListPageType,
  SET_LIST_HORSES_REQUEST_KEY,
  SET_SEARCH_QUERY,
  SET_SELECTED_FACILITY
} from "store/actions/trainerHorseListPage";

const initialState: ITrainerHorseListPageState = {
  selectedFacility: null,
  searchQuery: "",
  listHorsesRequestKey: null
};

export default (
  state = initialState,
  action: ITrainerHorseListPageType
): ITrainerHorseListPageState => {
  switch (action.type) {
    case SET_SELECTED_FACILITY:
      return {
        ...state,
        selectedFacility: action.selectedFacility
      };
    case SET_SEARCH_QUERY:
      return {
        ...state,
        searchQuery: action.searchQuery
      };
    case SET_LIST_HORSES_REQUEST_KEY:
      return {
        ...state,
        listHorsesRequestKey: action.listHorsesRequestKey
      };
    default:
      return state;
  }
};
